import React from 'react';
import invoke from 'lodash.invoke';
import cx from 'classnames';
import {FieldLabel, FieldWrapper, InputFeedback} from '../index';
import {useInputFocus} from '../hooks';

export const SelectField = ( {
                                 id,
                                 name,
                                 label,
                                 labelAppend,
                                 hint,
                                 error,
                                 errorShown,
                                 tooltip,
                                 value,
                                 isFocused,
                                 labelClassName,
                                 inputClassName,
                                 className,
                                 children,
                                 ...props
                             } ) => {

    const {fieldRef} = useInputFocus( isFocused );

    const handleBlur = e => invoke( props, 'onBlur', e );
    const handleChange = e => invoke( props, 'onChange', e );

    const groupClasses = cx(
        'select-group',
        className,
        {
            'animated shake error': !!error || !!errorShown
        }
    );

    const inputClasses = cx(
        'input-select w-full',
        {'disabled': props.disabled},
        inputClassName
    );

    return (
        <div className={groupClasses}>
            <FieldLabel
                label={label}
                append={labelAppend}
                tooltip={tooltip}
                id={id}
                hint={hint}
                error={error}
                className={labelClassName}
            />
                <FieldWrapper
                    component="select"
                    innerRef={fieldRef}
                    id={id}
                    name={name || id}
                    className={inputClasses}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={value}
                    {...props}>
                    {children}
                </FieldWrapper>
            <InputFeedback error={error}/>
        </div>
    );
}



